import React from "react";

const CardShadows = () => {
  return (
    <>
      <div
        style={{
          position: "relative",
        }}
      >
        <div
          className="glow heading-text-grouping"
          s
          style={{
            textAlign: "center",
            color: "white",
            marginBottom: "20px",
          }}
        >
          <h1 className="glow">WHAT EXACTLY IS FLASH USDT?</h1>
          <p>
            lash USDT is your go-to tool for crypto trading practice, product
            testing, or simply showing off your
            <br />
            virtual wealth. Here’s how it works:
          </p>
        </div>
      </div>
      <div className="card-grouping card-grouping1">
        <div className="row row-top-minus">
          <div
            className="col col-left-minus"
            style={{
              marginLeft: "-210px",
            }}
          >
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card"></div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic left graphic1">
                <div className="card-content">
                  <h2>SIMULATED, NO-RISK CURRENCY</h2>
                  <p>
                    Flash USDT functions like USDT but carries no real-world
                    value, ideal for practice and testing.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic right graphic2">
                <div className="card-content">
                  <h2>WALLET TRANSFERABILITY</h2>
                  <p>
                    Easily move Flash USDT between supported wallets and
                    exchanges for seamless use.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic right graphic3">
                <div className="card-content">
                  <h2>USED IN PRODUCT TESTING</h2>
                  <p>
                    Flash USDT is perfect for testing out trading platforms,
                    products, or new crypto features.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic right graphic4">
                <div className="card-content">
                  <h2>FUTURES & SPOT TRADING</h2>
                  <p>
                    Supports both futures and spot trading for full simulation
                    of real-world trading conditions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card"></div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
      </div>
      <div className="card-grouping card-grouping2">
        <div className="row row-top-minus">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>

          <div className="col">
            <div className="card"></div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic left graphic1">
                <div className="card-content">
                  <h2>SIMULATED, NO-RISK CURRENCY</h2>
                  <p>
                    Flash USDT functions like USDT but carries no real-world
                    value, ideal for practice and testing.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic left graphic2">
                <div className="card-content">
                  <h2>WALLET TRANSFERABILITY</h2>
                  <p>
                    Easily move Flash USDT between supported wallets and
                    exchanges for seamless use.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>

        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic right graphic3">
                <div className="card-content">
                  <h2>USED IN PRODUCT TESTING</h2>
                  <p>
                    Flash USDT is perfect for testing out trading platforms,
                    products, or new crypto features.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card card-text-grouping">
              <div className="graphic right graphic4">
                <div className="card-content">
                  <h2>FUTURES & SPOT TRADING</h2>
                  <p>
                    Supports both futures and spot trading for full simulation
                    of real-world trading conditions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
        <div className="row">
          <div className="col col-left-minus">
            <div className="card"></div>
          </div>
          <div className="col">
            <div className="card"></div>
          </div>
          <div className="col col-right-minus">
            <div className="card"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CardShadows;
